<template>
    <main class="toolbox-main">
      <div class="flex align-items-center justify-content-center down-container" @click="toggle"
           :class="fold==='up'?'up_fold':''" style="width: 60px">
        <i v-if="fold === 'up'" class="el-icon el-icon-d-arrow-left"></i>
        <i v-else class="el-icon el-icon-d-arrow-right"></i>
      </div>
      <div :class="fold==='up'?'an-show':'an-none'" class="flex column method-list">
        <div class="method-item" data-method="tailor" @click="$emit('tool', 'tailor')"></div>
        <el-popover
          popper-class="padding-0"
          placement="left"
          width="220"
          trigger="click">
          <el-card shadow="never" header="Tool">
            <el-form size="mini" label-width="80px" label-position="left">
              <el-form-item label="grid">
                <el-switch v-model="toolForm.grid" active-text="on" inactive-text="off"
                           @change="changeSetting('grid', $event)"></el-switch>
              </el-form-item>
              <el-form-item label="ruler">
                <el-switch v-model="toolForm.ruler" active-text="on" inactive-text="off"
                           @change="changeSetting('ruler', $event)"></el-switch>
              </el-form-item>
              <el-form-item label="navigator">
                <el-switch v-model="toolForm.navigator" active-text="on" inactive-text="off"
                           @change="changeSetting('navigator', $event)"></el-switch>
              </el-form-item>
              <el-form-item label="scale">
                <el-switch v-model="toolForm.graduation" active-text="on" inactive-text="off"
                           @change="changeSetting('graduation', $event)"></el-switch>
              </el-form-item>
              <el-form-item label="ratio">
                <el-switch v-model="toolForm.zoom" active-text="on" inactive-text="off"
                           @change="changeSetting('zoom', $event)"></el-switch>
              </el-form-item>
            </el-form>
          </el-card>
          <div slot="reference" class="method-item" data-method="setting"></div>
        </el-popover>
        <el-popover
          popper-class="padding-0"
          placement="left"
          width="200"
          trigger="click">
          <el-card shadow="never">
            <div class="flex">
              <div class="flex column align-items-center flex-1 relative">
                <div class="rotate_btn margin-b-1" @click="$emit('set-deg', 0)"></div>
                <div class="flex justify-content-center align-items-center">
                  <div class="rotate_btn margin-r-1" @click="$emit('set-deg', 270)"></div>
                  <div class="relative rotate_img_container">
                    <div class="rotate_img" :style="{transform: `rotate(${currentAngle}deg)`}" @mousedown="startRotate"
                         @mousemove="moveRotate" @mouseup="stopRotate" @mouseleave="stopRotate"></div>
                  </div>
                  <div class="rotate_btn margin-l-1" @click="$emit('set-deg', 90)"></div>
                </div>
                <div class="rotate_btn margin-t-1" @click="$emit('set-deg', 180)"></div>
              </div>
              <div class="angle-container
              flex column align-items-center justify-content-center margin-l-4">
                <i style="font-size: 24px" class="pointer el-icon-circle-plus-outline" @click="toggleAngle(1)"></i>
                <span class="margin-v-2">{{ currentAngle }}°</span>
                <i style="font-size: 24px" class="pointer el-icon-remove-outline" @click="toggleAngle(0)"></i>
              </div>
            </div>
          </el-card>
          <div slot="reference" class="method-item" data-method="rotate"></div>
        </el-popover>
        <!-- <el-popover
          popper-class="padding-0"
          placement="left"
          width="400"
          trigger="click">
          <el-card shadow="never" header="Image Processing">
            <el-form size="mini" class="process-form">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="Red channel">
                    <div class="flex align-items-center">
                      <el-slider
                        v-model="imageProcessForm.r"
                        class="flex-1"
                        :step="0.1"
                        :min="-1"
                        :max="1"
                        @change="$emit('force-redraw', imageProcessForm)"
                      />
                      <span class="margin-l-4">{{ imageProcessForm.r * 100 }}%</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Green channel">
                    <div class="flex align-items-center">
                      <el-slider
                        v-model="imageProcessForm.g"
                        class="flex-1"
                        :step="0.1"
                        :min="-1"
                        :max="1"
                        @change="$emit('force-redraw', imageProcessForm)"
                      />
                      <span class="margin-l-4">{{ imageProcessForm.g * 100 }}%</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Blue channel">
                    <div class="flex align-items-center">
                      <el-slider
                        v-model="imageProcessForm.b"
                        class="flex-1"
                        :step="0.1"
                        :min="-1"
                        :max="1"
                        @change="$emit('force-redraw', imageProcessForm)"
                      />
                      <span class="margin-l-4">{{ imageProcessForm.b * 100 }}%</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Gamma value">
                    <div class="flex align-items-center">
                      <el-slider
                        v-model="imageProcessForm.ga"
                        class="flex-1"
                        :step="0.01"
                        :min="-0.05"
                        :max="2"
                        @change="$emit('force-redraw', imageProcessForm)"
                      />
                      <span class="margin-l-4">{{ imageProcessForm.ga }}</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Saturation">
                    <div class="flex align-items-center">
                      <el-slider
                        v-model="imageProcessForm.s"
                        class="flex-1"
                        :step="0.1"
                        :min="-1"
                        :max="1"
                        @change="$emit('force-redraw', imageProcessForm)"
                      />
                      <span class="margin-l-4">{{ imageProcessForm.s * 100 }}%</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Brightness">
                    <div class="flex align-items-center">
                      <el-slider
                        v-model="imageProcessForm.l"
                        class="flex-1"
                        :step="0.1"
                        :min="-1"
                        :max="1"
                        @change="$emit('force-redraw', imageProcessForm)"
                      />
                      <span class="margin-l-4">{{ imageProcessForm.l * 100 }}%</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-button size="mini" @click="restProcess">Reset</el-button>
          </el-card>
          <div slot="reference" class="method-item" data-method="image-process"></div>
        </el-popover> -->
        <div class="method-item" data-method="info" @click="$emit('tool', 'image-info')"></div>
      </div>
    </main>
  </template>
  
  <script>
  import {getAngle, isPointInEllipse} from 'kfb-view';
  
  export default {
    name: 'HzztToolbox',
    data() {
      return {
        tips: '',
        tipsStyle: {},
        fold: 'up',
        toolForm: {
          grid: false,
          ruler: false,
          navigator: true,
          graduation: true,
          zoom: true,
          slide: true,
          diagnosis: true,
        },
        changeForm: {
          points: false,
          region: true,
        },
        imageProcessForm: {
          r: 0,
          g: 0,
          b: 0,
          s: 0,
          l: 0,
          ga: 1.2,
        },
        showLabelVisible: false,
        showAllLabel: true,
        focusView: sessionStorage.getItem('focus-view') || true,
      };
    },
    props: {
      currentAngle: {
        type: Number,
        default: 0,
      },
      next: Number,
      prev: Number,
      labelList: Array,
    },
    mounted() {
      document.addEventListener('keydown', this.handleWatchEnter);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleWatchEnter);
    },
    methods: {
      handleWatchEnter(e) {
        var key = window.event ? e.keyCode : e.which;
        if (key === 38&&this.prev) {
          this.$emit('new-case', 'prev');
        }else if(key === 40&&this.next){
          this.$emit('new-case', 'next');  
        }
      },
      toggle() {
        this.fold = this.fold === 'down' ? 'up' : 'down';
      },
      changeSetting(type, flag) {
        this.$emit('change-setting', type, flag);
      },
      restProcess() {
        this.imageProcessForm = {
          r: 0,
          g: 0,
          b: 0,
          s: 0,
          l: 0,
          ga: 1.2,
        };
        this.$emit('force-redraw', this.imageProcessForm);
      },
      startRotate(e) {
        const {x, y} = e;
        const el = document.querySelector('.rotate_img_container');
        const boundRect = el.getBoundingClientRect();
        const currentPoint = {
          x: x - boundRect.left,
          y: y - boundRect.top,
        };
        if (isPointInEllipse(currentPoint, {x: 32, y: 32}, 32, 32)) {
          const angle = getAngle({x: 32, y: 32}, {x: 32, y: 0}, currentPoint);
          if (isNaN(angle / Math.PI * 180)) return;
          let deg = (angle / Math.PI * 180).toFixed(2) / 1;
          if (deg < 0) {
            deg = 360 + deg;
          }
          this.isRotating = true;
          this.$emit('set-deg', deg);
        }
      },
      moveRotate(e) {
        if (this.isRotating) {
          this.startRotate(e);
        }
      },
      stopRotate(e) {
        this.isRotating = false;
      },
      toggleAngle(flag) {
        if (flag) {
          const currentAngle = this.currentAngle + 5;
          if (currentAngle > 360) {
            this.$emit('set-deg', currentAngle - 360);
          } else {
            this.$emit('set-deg', currentAngle);
          }
        } else {
          const currentAngle = this.currentAngle - 5;
          if (currentAngle < 0) {
            this.$emit('set-deg', 360 + currentAngle);
          } else {
            this.$emit('set-deg', currentAngle);
          }
        }
      },
      changeShowLabel(){
        this.$emit('change-show-label',this.showAllLabel)
      }
    },
  };
  </script>
  
  <style scoped lang="scss">
  /* stylelint-disable */
  .toolbox-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 5px; /*no*/
    right: 10px; /*no*/
    z-index: 2;
  
    .down-container {
      width: 60px; /*no*/
      height: 30px;
      background: #84B5FF;
      border-radius: 12px;
      cursor: pointer;
  
      .el-icon {
        transform: rotate(90deg);
        color: white;
        font-size: 18px;
      }
  
      &.up_fold {
        border-radius: 12px 12px 0 0; /*no*/
      }
    }
  
    .method-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 60px; /*no*/
      background: #3B55BFB2;
      transition: height .3s;
  
      &.an-none {
        display: none;
        height: 0;
      }
  
      &.an-show {
        height: auto;
      }
  
      .method-item {
        width: 60px; /*no*/
        height: 30px; /*no*/
        margin: 10px 0 0;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 21px 21px; /*no*/
        cursor: pointer;
  
        &:hover {
          background-color: #3B55BF;
        }
  
        &[data-method="scan_qrcode"] {
          background-image: url(@/assets/img/kfb-view/scan_qrcode.png);
        }
  
        &[data-method="slice_list"] {
          background-image: url(@/assets/img/kfb-view/slice_list.png);
        }
  
        &[data-method="board"] {
          background-image: url(@/assets/img/kfb-view/board.png);
        }
  
        &[data-method="label_list"] {
          background-image: url(@/assets/img/kfb-view/label_list.png);
        }
  
        &[data-method="evaluate"] {
          background-image: url(@/assets/img/kfb-view/evaluate.png);
        }
  
        &[data-method="tailor"] {
          background-image: url(@/assets/img/kfb-view/tailor.png);
        }
  
        &[data-method="json"] {
          background-image: url(@/assets/img/kfb-view/json.svg);
        }
  
        &[data-method="image_list"] {
          background-image: url(@/assets/img/kfb-view/image_list.png);
        }
  
        &[data-method="setting"] {
          background-image: url(@/assets/img/kfb-view/setting.png);
        }
  
        &[data-method="rotate"] {
          background-image: url(@/assets/img/kfb-view/rotate.png);
        }
  
        &[data-method="video"] {
          background-image: url(@/assets/img/kfb-view/video.png);
        }
  
        &[data-method="image-process"] {
          background-image: url(@/assets/img/kfb-view/advice.png);
        }
  
        &[data-method="change"] {
          background-image: url(@/assets/img/kfb-view/change.svg);
        }
  
        &[data-method="info"] {
          background-image: url(@/assets/img/kfb-view/info.png);
          margin-bottom: 10px;
        }
      }
    }
  
    .toolbox-tips {
      display: none;
      position: absolute;
      top: 0;
      left: 55px;
      padding: 5px 20px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 3px;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      white-space: nowrap;
  
      &:after {
        content: "";
        position: absolute;
        left: -10px;
        top: 50%;
        margin-top: -5px;
        border-width: 5px;
        border-color: transparent rgba(0, 0, 0, 0.6) transparent transparent;
        border-style: solid;
      }
    }
  }
  .el-card {
    border: none;
  
    :deep(.el-card__header) {
      padding: 5px 10px;
    }
  }
  
  .el-form-item--mini {
    margin-bottom: 10px;
  }
  
  .process-form {
    :deep(.el-slider__runway) {
      margin: 11px 0;
    }
  }
  
  .angle-container {
    width: 50px;
    color: #3B55BF;
  }
  
  .rotate_btn {
    cursor: pointer;
    width: 10px;
    height: 10px;
    background: #3B55BF;
  }
  
  .rotate_img_container {
    width: 64px;
    height: 64px;
  }
  
  .rotate_img {
    position: absolute;
    left: 0;
    right: 0;
    cursor: pointer;
    user-select: none;
    width: 64px;
    height: 64px;
    background-size: 64px;
    background-image: url("@/assets/img/kfb-view/rotate_arrow.png");
  }
  
  .img-container {
    cursor: pointer;
    padding: 5px;
  
    &:hover {
      background: #84B5FF;
    }
  }
  ::v-deep{
    .switchStyle .el-switch__label {
      position: absolute;
      display: none;
    }
   .el-switch__core{
      background-color: rgba(166, 166, 166, 1) ;
    }
    .switchStyle .el-switch__label--left {
      z-index: 9;
      left: 20px;
      color: #3B55BF;
    }
    .switchStyle .el-switch__label--right {
      z-index: 9;
      left: 4px;
      color: #fff;
    }
    .switchStyle .el-switch__label.is-active {
      display: block;
    }
    .switchStyle.el-switch .el-switch__core,
    .el-switch .el-switch__label {
      width: 18px !important;
    }
  }
  </style>
  